import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link } from 'react-router-dom';



function HeaderBest() {
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>

  <header>
    <div className="tg-header__top">
      <div className="container-fluid p-0">
        <div className="row align-items-center">
          <div className="col-xl-7">
            <ul className="tg-header__top-info left-side list-wrap">
              <li>
                <i className="flaticon-location-1" />
                Houston Texas 77029 , USA
              </li>
              <li>
                <i className="flaticon-envelope" />
                <a href="mailto:operation@mtlship.us">operation@mtlship.us</a>
              </li>
              <li>
                <i className="flaticon-time" />
                Mon – Fri: 8.30 - 17.30 EST
              </li>
            </ul>
          </div>
          <div className="col-xl-5">
            <div className="tg-header__top-right">
              <ul className="tg-header__top-menu list-wrap">
              <li>

                <Link to="/databank">
                  <span>Help Center</span>
                  </Link>
                  </li>
            
              </ul>
              <div className="tg-header__top-social">
                <span>Follow Us On:</span>
                <ul className="list-wrap">
             
                
                  <li>
                    <a href="https://wa.me/15516559226" target="_blank">
                      <i className="fab fa-whatsapp" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
            
              
                  <li>
                    <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </li>
            
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={`sticky-menu ${scrolled ? "scrolled" : ""}`}>

      <div className="container-fluid p-0">
        <div className="row gx-0">
          <div className="col-12">
            <div className="tgmenu__wrap">
              <div className="tgmenu__nav-left-side">
                <div className="offcanvas-toggle">
                  <button 
                    className="menu-tigger creax"
                    onClick={toggleOffCanvas}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={30}
                      height={30}
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M1.66669 15H28.3334M1.66669 6.66666H28.3334M1.66669 23.3333H28.3334"
                        stroke="currentcolor"
                        strokeWidth="1.83333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div className="logo">
                  <Link to="/">
                    <img src="/assets/img/mtllogo.png" alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="tgmenu__navbar-wrap tgmenu__main-menu d-none d-xl-flex">
                <ul className="navigation">
                  <li >
                    <Link to="/">Home</Link>
              
                  </li>
                  <li>
                  <Link to="/aboutus">About Us</Link>
                  </li>
                  <li>
                      <Link to="/services">Services</Link>
                    </li>
                  <li >
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/databank">Databank</Link>
                  </li>
                     <li>
                    <Link to="/getoffer">Get Offer</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
               
               
                </ul>
              </div>
              <div className="tgmenu__action d-none d-md-flex">
                <ul className="list-wrap">
                  <li className="header-search">
                    <a href="#" onClick={(e) => {
                      e.preventDefault();
                      toggleSearch();
                    }} className="search-open-btn">
                      <i className="flaticon-search" style={{opacity: '0'}} />
                    </a>
                  </li>
                  <li className="header-contact">
                    <div className="icon">
                      <i className="flaticon-telephone" />
                    </div>
                    <div className="content">
                      <span>Get in touch:</span>
                      <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </div>
                  </li>
                  <li className="header-btn">
                    <a href="/trackorder" className="btn">
                      <i className="flaticon-uptrend" />
                      Track Order
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                <i className="fas fa-bars" style={{ 
                  color: '#fff',
                  fontSize: '24px'
                }} />
              </div>
            </div>
            {/* Mobile Menu  */}
            <div className={`tgmobile__menu ${isMobileMenuOpen ? 'disopac' : ''}`}>
              <nav className="tgmobile__menu-box">
                <div className="close-btn" onClick={toggleMobileMenu} style={{
                  position: 'absolute',
                  right: '20px',
                  top: '20px',
                  cursor: 'pointer',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#c51524',
          
                  transition: 'all 0.3s ease'
                }}>
                  <i className="fas fa-times" style={{ 
                    color: '#fff',
                    fontSize: '20px',
                    fontWeight: 'bold'
                  }} />
                </div>
                <div className="nav-logo">
                <Link to="/">
                    <img src="/assets/img/mtllogo.png" alt="Logo" />
                  </Link>
                </div>
                <div className="tgmobile__search" style={{opacity: '0'}}>
                  <form action="#">
                    <input type="text" placeholder="Search here..." />
                    <button>
                      <i className="fas fa-search" />
                    </button>
                  </form>
                </div>
                <div className="tgmobile__menu-outer">
                  {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                  <ul className="navigation">
                    <li >
                    <Link to="/">
                      Home
                      </Link>
                 
                    </li>
                    <li>
                    <Link to="/aboutus">About Us</Link>
                    </li>
                    <li>
                      <Link to="/services">Services</Link>
                    </li>
                    <li >
                    <Link to="/blog">Blog</Link>
                   
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <Link to="/getoffer">Get Offer</Link>
                    </li>
                    <li>
                      <Link to="/trackorder">Track Order</Link>
                    </li>
                  </ul>
                </div>
                <div className="social-links">
                  <ul className="list-wrap">
                  <li>
                    <a href="https://wa.me/18325621002" target="_blank">
                      <i className="fab fa-whatsapp" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
            
              
                  <li>
                    <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div 
              className={` tgmobile__menu-backdrop ${isMobileMenuOpen ? 'disopac2' : ''}`} 
              onClick={closeMobileMenu}
            />
            {/* End Mobile Menu */}
          </div>
        </div>
      </div>
    </div>
    {/* header-search */}
    <div className={`search__popup ${isSearchOpen ? 'search__popup-open' : ''}`}>
      <div className="search__wrapper">
        <div className="search__close">
          <a href="#" onClick={(e) => {
            e.preventDefault();
            setIsSearchOpen(false);
          }}>
            <i className="fas fa-times" />
          </a>
        </div>
        <div className="search__content" style={{width: '100%'}}>
          <form action="#" onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Search for products..." />
            <button type="submit">
              <i className="flaticon-search" style={{opacity: '0'}} />
            </button>
          </form>
        </div>
      </div>
    </div>
    <div className="search-popup-overlay" />
    {/* header-search-end */}
    {/* offCanvas-menu */}
    <div className={`offCanvas__info ${isOffCanvasOpen ? 'active' : ''}`}>
      <div className="offCanvas__close-icon menu-close">
        <button onClick={toggleOffCanvas}>
          <i className="far fa-window-close" />
        </button>
      </div>
      <div className="offCanvas__logo mb-30">
        <a href="index.html">
          <img src="/assets/img/mtllogo.png" alt="Logo" />
        </a>
      </div>
      <div className="offCanvas__side-info mb-30">
        <div className="contact-list mb-30">
          <h4>Office Address</h4>
          <p>
          8451 Market Street ste 138,
          <br /> Houston Texas 77029  , USA
          </p>
        </div>
        <div className="contact-list mb-30">
          <h4>Phone Number</h4>
          <a href="tel:+18325621002">(+1) 832 562 1002</a>
        </div>
        <div className="contact-list mb-30">
          <h4>Email Address</h4>
          <a href="mailto:info@gmail.com">operation@mtlship.us</a>
        </div>
      </div>
      <div className="offCanvas__social-icon mt-30">
                    <a href="https://wa.me/15516559226" target="_blank">
                      <i className="fab fa-whatsapp" />
                    </a>
                    <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                      <i className="fab fa-instagram" />
                    </a>
            
              
                    <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                      <i className="fab fa-linkedin-in" />
                    </a>
      </div>
    </div>
    <div 
      className={`offCanvas__overly ${isOffCanvasOpen ? 'active' : ''}`} 
      onClick={toggleOffCanvas}
    />
    {/* offCanvas-menu-end */}
  </header>


    </>
  );
}

export default HeaderBest;

<style jsx>{`
  .search__popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  .search__popup-open {
    opacity: 1;
    visibility: visible;
  }

  .search__wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search__close {
    position: absolute;
    top: 40px;
    right: 40px;
  }

  .search__close a {
    color: #fff;
    font-size: 24px;
    transition: all 0.3s ease;
  }

  .search__close a:hover {
    color: #c51524;
  }

  .search__content {
    width: 100%;
    max-width: 600px;
    padding: 0 20px;
  }

  .search__content form {
    position: relative;
    width: 100%;
  }

  .search__content input {
    width: 100%;
    height: 60px;
    background: transparent;
    border: none;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    font-size: 18px;
    padding: 0 50px 0 0;
  }

  .search__content input:focus {
    outline: none;
    border-bottom-color: #c51524;
  }

  .search__content input::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  .search__content button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .search__content button:hover {
    color: #c51524;
  }

  @media (max-width: 767px) {
    .search__close {
      top: 20px;
      right: 20px;
    }

    .search__content input {
      font-size: 16px;
    }
  }
`}</style>

